import { MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";

export const OptionMenuItem = styled(MenuItem)(() => ({
  height: "44px",
  display: "flex",
  alignItems: "center",
}));
